import { BookmarkModel } from './bookmark.model';

export class BookmarkActionEvent {
  name: BookmarkAction;
  id: string;
  bookmark: BookmarkModel;
}

export enum BookmarkAction {
  View = 'View',
  Edit = 'Customize in Studio',
  Manage = 'Manage',
  Publish = 'Publish',
  Delete = 'Delete',
  CopyURL = 'Copy URL',
  AddToMyLibrary = 'Add to My Library',
  Divider = '',
}
